export class StandardType {
  id: number;
  name: string;
  constructor(obj?: StandardType) {
    if (obj) {
      this.id = obj.id;
      this.name = obj.name;
    }
  }
}
